import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="container">
        <p>Indian Society of Polycystic Kidney Disease   &copy; 2025 - {currentYear}. All Rights Reserved.</p>
      
      </div>
    </footer>
  );
};

export default Footer;